/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "body_prose_size_default": "prose-p:!mt-0",
  "body_prose_size_alternative": "prose-p:!mt-0",
  "body_prose_colors_default": "",
  "body_prose_variant_default": "prose-coverbox sm:prose-coverbox",
  "body_prose_variant_alternative": "",
  "body_size_default": "max-w-[790px]",
  "body_size_alternative": "",
  "body_colors_default": "",
  "body_variant_default": "relative group desktop:line-clamp-none data-[expanded=\"true\"]:!line-clamp-none",
  "body_variant_alternative": "relative group desktop:line-clamp-none data-[expanded=\"true\"]:!line-clamp-none",
  "group_size_default": "gap-1",
  "group_size_alternative": "sm:gap-6",
  "group_colors_default": "",
  "group_variant_default": "flex flex-col",
  "group_variant_alternative": "flex flex-col sm:flex-row sm:items-center",
  "expand_size_default": "text-el-preview-sm font-medium",
  "expand_size_alternative": "text-body-sm font-bold",
  "expand_colors_default": "bg-white",
  "expand_variant_default": "absolute bottom-0 right-0 cursor-pointer hover:underline group-data-[clamped=\"false\"]:hidden",
  "expand_variant_alternative": "absolute bottom-0 right-0 font-primary cursor-pointer hover:underline group-data-[clamped=\"false\"]:hidden",
  "headline_size_default": "text-el-gabor-lg",
  "headline_size_alternative": "text-headline",
  "headline_colors_default": "text-black",
  "headline_variant_default": "text-capitalize",
  "headline_variant_alternative": "capitalize",
  "icon_size_default": "",
  "icon_size_alternative": "",
  "icon_colors_default": "",
  "icon_variant_default": "",
  "icon_variant_alternative": "",
  "images_size_default": "",
  "images_size_salternative": "",
  "images_colors_default": "",
  "images_variant_default": "",
  "images_variant_alternative": "",
  "size_default": "gap-1 py-0 w-full sm:gap-6",
  "size_alternative": "w-full gap-6 p-3 sm:p-6",
  "colors_default": "",
  "variant_default": "flex flex-col",
  "variant_alternative": "flex flex-row sm:items-center mobile:flex-row-reverse justify-center"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "ContentCoverBox");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;